"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var ExternalLink_1 = require("../../components/globals/ExternalLink");
var ClientHeader_1 = require("../../components/globals/ClientHeader");
var Policy_1 = require("../../components/globals/Policy");
var RoomInfoModule_1 = require("../../store/modules/RoomInfoModule");
var vuex_module_decorators_1 = require("vuex-module-decorators");
var axios_1 = require("axios");
var OfficeInfoModule_1 = require("../../store/modules/OfficeInfoModule");
var Room_1 = require("./Room");
var LoadingModule_1 = require("../../store/modules/LoadingModule");
var SimpleDialog_1 = require("../../components/globals/SimpleDialog");
var ismobilejs_1 = require("ismobilejs");
var ClientTop = /** @class */ (function (_super) {
    __extends(ClientTop, _super);
    function ClientTop() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.numbers = [1, 2, 3, 4, 5, 6, 7, 8, 9];
        _this.roomNo = '';
        _this.officeName = '';
        _this.isShowDialog = false;
        _this.dialogMessage = '';
        return _this;
    }
    ClientTop_1 = ClientTop;
    ClientTop.prototype.loadStart = function () {
        this.setLoading(true);
    };
    ClientTop.prototype.loadEnd = function () {
        this.setLoading(false);
    };
    ClientTop.prototype.setLoading = function (loading) {
        var storeInstance = vuex_module_decorators_1.getModule(LoadingModule_1.default, this.$store);
        storeInstance.setLoading(loading);
    };
    ClientTop.prototype.numberClick = function (numberStr) {
        if (ismobilejs_1.default().any) {
            return;
        }
        this.numberAdd(numberStr);
    };
    ClientTop.prototype.numberHover = function (numberStr) {
        if (!ismobilejs_1.default().any) {
            return;
        }
        this.numberAdd(numberStr);
    };
    ClientTop.prototype.numberAdd = function (numberStr) {
        if (this.roomNo.length >= ClientTop_1.MAX_ROOMNO_LENGTH) {
            return;
        }
        this.roomNo += numberStr;
    };
    ClientTop.prototype.removeClick = function () {
        if (ismobilejs_1.default().any) {
            return;
        }
        this.removeRoomNo();
    };
    ClientTop.prototype.removeHover = function () {
        if (!ismobilejs_1.default().any) {
            return;
        }
        this.removeRoomNo();
    };
    ClientTop.prototype.removeRoomNo = function () {
        if (!this.roomNo.length) {
            return;
        }
        this.roomNo = this.roomNo.slice(0, -1);
    };
    /**
     */
    ClientTop.prototype.getOfficeName = function () {
        return this.officeName;
    };
    ClientTop.prototype.isButtonDark = function () {
        return !this.isButtonDisable();
    };
    ClientTop.prototype.isButtonDisable = function () {
        return this.roomNo.length !== ClientTop_1.MAX_ROOMNO_LENGTH;
    };
    ClientTop.prototype.getRoomNoByIndex = function (index) {
        if (this.roomNo.length <= index) {
            return '　';
        }
        return this.roomNo.substr(index, 1);
    };
    Object.defineProperty(ClientTop, "MAX_ROOMNO_LENGTH", {
        get: function () {
            return 4;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 起動時の処理
     * */
    ClientTop.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            var self_, url_, result, storeInstance;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        self_ = this;
                        self_.disableZoom();
                        self_.loadStart();
                        url_ = self_.$invokeUrlMaker.create("office/name/" + this.getOfficeId());
                        return [4 /*yield*/, axios_1.default.get(url_)];
                    case 1:
                        result = _a.sent();
                        if (!result.data['officeName']) {
                            self_.loadEnd();
                            this.showDialog('URL が間違っています。事業所に連絡して確認してください');
                            return [2 /*return*/];
                        }
                        storeInstance = vuex_module_decorators_1.getModule(OfficeInfoModule_1.default, this.$store);
                        storeInstance.setOfficeName(result.data['officeName']);
                        this.officeName = result.data['officeName'];
                        console.log("******************************");
                        console.log(this.officeName.length);
                        self_.loadEnd();
                        return [2 /*return*/];
                }
            });
        });
    };
    ClientTop.prototype.startRehabOnline = function () {
        return __awaiter(this, void 0, void 0, function () {
            var self_, url_, params, result, storeInstance;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        self_ = this;
                        self_.loadStart();
                        url_ = self_.$invokeUrlMaker.create('get_room');
                        params = JSON.stringify({
                            officeId: self_.getOfficeId(),
                            roomNo: Number(this.roomNo)
                        });
                        return [4 /*yield*/, axios_1.default.post(url_, params).catch(function (res) {
                                return;
                            })];
                    case 1:
                        result = _a.sent();
                        if (!result) {
                            self_.loadEnd();
                            this.showDialog('部屋番号が間違っています。事業所に連絡して確認してください。');
                            return [2 /*return*/];
                        }
                        if (!result.data['roomInfo']) {
                            self_.loadEnd();
                            this.showDialog('部屋番号が間違っています。事業所に連絡して確認してください。');
                            return [2 /*return*/];
                        }
                        storeInstance = vuex_module_decorators_1.getModule(RoomInfoModule_1.default, this.$store);
                        storeInstance.setMeetingStarted(true);
                        storeInstance.setRoomNo(Number(this.roomNo));
                        storeInstance.setRoomUrl(result.data['roomInfo']['roomUrl']);
                        storeInstance.setMeetingStarted(true);
                        self_.loadEnd();
                        return [2 /*return*/];
                }
            });
        });
    };
    ClientTop.prototype.isMeetingStarted = function () {
        var storeInstance = vuex_module_decorators_1.getModule(RoomInfoModule_1.default, this.$store);
        return storeInstance.meetingStarted;
    };
    ClientTop.prototype.getOfficeId = function () {
        return this.$route.params['office_id'];
    };
    ClientTop.prototype.disableZoom = function () {
        var self_ = this;
        self_.$log.info("This page can not zoom");
        if (self_.isMeetingStarted()) {
            return true;
        }
        document.documentElement.addEventListener('touchstart', function (e) {
            if (e.touches.length >= 2) {
                e.preventDefault();
            }
        }, { passive: false });
        /* ダブルタップによる拡大を禁止 */
        var t = 0;
        document.documentElement.addEventListener('touchend', function (e) {
            var now = new Date().getTime();
            if ((now - t) < 350) {
                e.preventDefault();
            }
            t = now;
        }, false);
    };
    ClientTop.prototype.dialogClose = function () {
        this.isShowDialog = false;
    };
    ClientTop.prototype.showDialog = function (msg) {
        this.dialogMessage = msg;
        this.isShowDialog = true;
    };
    var ClientTop_1;
    ClientTop = ClientTop_1 = __decorate([
        vue_property_decorator_1.Component({
            components: {
                SimpleDialog: SimpleDialog_1.default,
                Room: Room_1.default,
                Policy: Policy_1.default,
                ClientHeader: ClientHeader_1.default,
                ExternalLink: ExternalLink_1.default
            }
        })
    ], ClientTop);
    return ClientTop;
}(vue_property_decorator_1.Vue));
exports.default = ClientTop;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/client/Top.vue
// module id = NoBU
// module chunks = 1